import React, { ReactElement } from "react";
import ModConfirm from "react-lib/apps/common/cnmi/ModConfirm";

const COLORS = {
  chat_light: "var(--primary-theme-chat-light)",
};

type ModConfirmCustomProps = {
  // data
  open: boolean;
  approveText?: string;
  denyText?: string;
  content?: ReactElement;

  // callback
  onApprove: () => void;
  onDeny: () => void;
};

const ModConfirmCustom = React.memo<ModConfirmCustomProps>((props) => {
  return (
    <ModConfirm
      openModal={props.open}
      basic={false}
      titleColor="red"
      approveButtonStyle={{
        backgroundColor: COLORS.chat_light,
        color: "#121010",
        fontWeight: "normal",
      }}
      approveButtonText={props.approveText}
      denyButtonStyle={{
        backgroundColor: "#cecdcd",
        color: "#121010",
        fontWeight: "normal",
      }}
      denyButtonText={props.denyText}
      textContent={props.content}
      onCloseWithDimmerClick={props.onDeny}
      onDeny={props.onDeny}
      onApprove={props.onApprove}
    />
  );
});

ModConfirmCustom.displayName = "ModConfirmCustom";

export default ModConfirmCustom;
